import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IPerfilAcesso } from '../../roles/models/role';
import { RolesService } from '../../roles/services/roles.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { AtendenteService } from '../services/atendente.service';
import { DeviceAtendenteService } from '../services/device-atendente.service';
import { IDevice, IListByFilterDevices } from '../../devices/models/device.interface';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';

@Component({
  selector: 'app-edit-devices-atendente',
  templateUrl: './edit-devices-atendente.component.html',
  styleUrls: ['./edit-devices-atendente.component.scss']
})
export class EditDevicesAtendenteComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  atendenteId?: string | null;

  formDevicesAtendente = new UntypedFormGroup({
    id: new UntypedFormControl('', [Validators.required]),
    fullName: new UntypedFormControl('', [Validators.required]),
    companyId: new UntypedFormControl(null),
    adminUserProfileId: new UntypedFormControl(null, [Validators.required]),
    adminUserProfile: new UntypedFormControl(null),
    accountRole: new UntypedFormControl(null),
    devices: new UntypedFormControl([])
  });

  opcoesPerfilAcesso: IPerfilAcesso[] = [];
  devices: IDevice[] = [];

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly atendentesService: AtendenteService,
    private readonly roleService: RolesService,
    private readonly toastService: ToastService,
    private readonly sessionService: SessionService,
    private readonly deviceAtendenteService: DeviceAtendenteService
  ) { }

  public ngOnInit(): void {
    this.atendenteId = this.activatedRoute.snapshot.paramMap.get('id');
    if (this.atendenteId) {
      this.carregarDetalhesAtendente(this.atendenteId);
    }
  }

  public carregarDetalhesAtendente(atendenteId: string): void {
    this.formDevicesAtendente.get('id')!.patchValue(atendenteId);

    this.atendentesService.detalheAtendente(atendenteId).subscribe((res) => {
      if (res.messages && res.messages.length > 0) {
        this.toastService.toast(res.messages);
      }
      this.formDevicesAtendente.get('id')!.patchValue(res.data.id);
      this.formDevicesAtendente.get('fullName')!.patchValue(res.data.fullName);
      this.formDevicesAtendente.get('adminUserProfileId')!.patchValue(res.data.adminUserProfileId);
      this.formDevicesAtendente.get('accountRole')!.patchValue(res.data.accountRole);
      this.formDevicesAtendente.get('companyId')!.patchValue(res.data.companyId)
      this.getDevices();

    });
  }

  public editarAtendente(): void {
    // Fazer a lógica dessa função, quando o dispositivo e atendente estiverem ligados.  
  }

  getDevices(): void {
    const company = this.sessionService.getSession().companyId;

    const filter: IListByFilterDevices = {
      pageNumber: 0,
      pageSize: 10,
      orderBy: EOrdenacao.AlfabeticaAZ,
    };

    const teste = company || this.formDevicesAtendente.get('companyId')?.value;

    if (teste) {
      filter.companyId = String(teste);
    }

    this.deviceAtendenteService.listDevices(filter).subscribe((resposta) => {
      this.devices = resposta.data;
    });
  }
}